/*
 * The admin bundle.
 *
 * Alpine and its plugins are set up in ./admin/alpine, which every module below
 * imports. That is deliberate: a plugin's magics do not exist until its plugin()
 * call has run, and registering them here would put them after every module that
 * uses one, because imports are hoisted.
 */
import Alpine from './admin/alpine'

import './admin/stores'
import './admin/automation-builder'
import './admin/components'
import './admin/editor'
import './admin/draft-order'
import './admin/live-view'
import './admin/master-product'
import './admin/search'
import './admin/segment-builder'
import './admin/field-builder'
import './admin/stock-lines'
import './admin/till'

window.Alpine = Alpine

Alpine.start()
